import { FC, ReactNode, useEffect } from 'react';
import { pageviewTracker } from '../services/posthog/pageviewTracker';
import { usePageviewLocation } from '../services/posthog/usePageviewLocation';

/**
 * @description Wraps a route's page and tells the pageview tracker that the page has rendered, so the
 * PostHog $pageview is sent after the page (and any experiment exposure) rather than at the URL change.
 * The effect depends on the pathname because React reuses this wrapper across sibling routes.
 */
export const TrackedPage: FC<{ children: ReactNode }> = ({ children }) => {
  const location = usePageviewLocation();

  useEffect(() => {
    pageviewTracker.markRendered(location);
  }, [location.pathname]);

  return children;
};
